export const upgradesEnabled = import.meta.env.VITE_UPGRADES_ENABLED !== 'false'
